import React, { createContext, useContext, useState } from "react";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (payload) => {
    const newNotif = {
      id: Date.now(),
      title: payload.notification.title,
      body: payload.notification.body,
      read: false,
    };

    setNotifications((prev) => [newNotif, ...prev]);
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <NotificationContext.Provider value={{ notifications, addNotification, unreadCount }}>
      {children}
    </NotificationContext.Provider>
  );
};